var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallerInbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2246_16326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 16C10 11.5817 13.5817 8 18 8C22.4183 8 26 11.5817 26 16C26 20.4183 22.4183 24 18 24C13.5817 24 10 20.4183 10 16Z",
    fill: "#9DD9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7206 16.293H17.7136C14.9266 16.293 12.666 18.5535 12.666 21.3335H17.7206V16.293Z",
    fill: "#007FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.366 10.6624H23.3589C20.5789 10.6624 18.3184 12.9159 18.3184 15.7029H23.373V10.6624H23.366Z",
    fill: "#007FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3098 21.3335H18.3168C21.0968 21.3335 23.3574 19.08 23.3574 16.293H18.3027V21.3335H18.3098Z",
    fill: "#007FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 22.5C14.4101 22.5 11.5 19.5899 11.5 16H8.5C8.5 21.2467 12.7533 25.5 18 25.5V22.5ZM24.5 16C24.5 19.5899 21.5899 22.5 18 22.5V25.5C23.2467 25.5 27.5 21.2467 27.5 16H24.5ZM18 9.5C21.5899 9.5 24.5 12.4101 24.5 16H27.5C27.5 10.7533 23.2467 6.5 18 6.5V9.5ZM18 6.5C12.7533 6.5 8.5 10.7533 8.5 16H11.5C11.5 12.4101 14.4101 9.5 18 9.5V6.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2246_16326",
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2246_16326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2246_16326",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallerInbox);
export default __webpack_public_path__ + "static/media/caller-inbox.5bb4363a6c5ea949bcc65b6ba3da4a10.svg";
export { ForwardRef as ReactComponent };